import {getAmplitudeLeadFormInquiryTopicsSelected, IAmplitudeLeadFormCloseFormSnapshot} from "./get_amplitude_lead_form_inquiry_topics_selected";
import {getAmplitudeLeadFormStartEventProperties, IGetAmplitudeLeadFormStartEventPropertiesParams} from "./get_amplitude_lead_form_start_event_properties";

export interface IGetAmplitudeLeadFormCloseEventPropertiesParams extends IGetAmplitudeLeadFormStartEventPropertiesParams {
    formSnapshot?: IAmplitudeLeadFormCloseFormSnapshot;
}

export const getAmplitudeLeadFormCloseEventProperties = (params: IGetAmplitudeLeadFormCloseEventPropertiesParams) => {
    const {formSnapshot, ...startParams} = params;

    return {
        ...getAmplitudeLeadFormStartEventProperties(startParams),
        inquiry_topics_selected: getAmplitudeLeadFormInquiryTopicsSelected(startParams.source, formSnapshot)
    };
};
import {getAmplitudeLeadFormInquiryTopicsSelected, IAmplitudeLeadFormCloseFormSnapshot} from "./get_amplitude_lead_form_inquiry_topics_selected";
import {getAmplitudeLeadFormStartEventProperties, IGetAmplitudeLeadFormStartEventPropertiesParams} from "./get_amplitude_lead_form_start_event_properties";

export interface IGetAmplitudeLeadFormCloseEventPropertiesParams extends IGetAmplitudeLeadFormStartEventPropertiesParams {
    formSnapshot?: IAmplitudeLeadFormCloseFormSnapshot;
}

export const getAmplitudeLeadFormCloseEventProperties = (params: IGetAmplitudeLeadFormCloseEventPropertiesParams) => {
    const {formSnapshot, ...startParams} = params;

    return {
        ...getAmplitudeLeadFormStartEventProperties(startParams),
        inquiry_topics_selected: getAmplitudeLeadFormInquiryTopicsSelected(startParams.source, formSnapshot)
    };
};
